import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formatMoney, url } from "@/utils";
import { DataGrid } from "@mui/x-data-grid";
import { Stack } from "@mui/material";
import OptionsMenu from "@/components/core/TableOptionMenu";
import { OrderData } from "@/data/dtos/order.dto";
import { getAll, remove } from "@/actions/invoice.action";
import { InvoiceDto } from "@/data/dtos/invoice.dto";
import { trTR } from "@mui/x-data-grid/locales";
import Skeleton from "react-loading-skeleton";

export default function InvoiceList() {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const { invoices } = useSelector((state: any) => state.invoices);
  const [loading, setLoading] = React.useState(true);

  const handleDelete = async (id) => {
    dispatch(remove(id) as any);
  };

  useEffect(() => {
    let isMounted = true;
    const fetchInvoices = async () => {
      if (isMounted) {
        dispatch(getAll() as any);
      }
      setLoading(false);
    };
    fetchInvoices();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const pageSizeOptions = [25, 50, 100];

  const columns = [
    {
      field: "orderId",
      headerName: "Sipariş No",
      flex: 0.3,
    },
    {
      field: "invoiceNo",
      headerName: "Müşteri Fatura No",
      flex: 0.3,
    },
    {
      field: "totalprice",
      headerName: "Tahsil Edilen Toplam Tutar",
      flex: 0.3,
      valueGetter: (param: any) => formatMoney(param),
    },
    {
      field: "paymentChannel",
      headerName: "Ödeme Kanalı",
      flex: 0.2,
    },
    {
      field: "installmentCount",
      headerName: "Ödeme Şekli",
      flex: 0.1,
    },
    {
      field: "paymentStatus",
      headerName: "Tahsil Durumu",
      flex: 0.1,
    },
    {
      field: "options",
      headerName: "Seçenekler",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
          event.stopPropagation(); // Prevent row selection on click
          // You can manage the menu state in the parent or directly in the component
        };

        return (
          <Stack direction="row" spacing={1}>
            <OptionsMenu
              id={params.row._id}
              onEdit={() => {
                navigation(url("Admin.Orders.Edit", { id: params.row._id }));
              }}
              onDelete={handleDelete}
              onOpenMenu={handleMenuOpen} // Pass the handler to OptionsMenu
            />
          </Stack>
        );
      },
    },
  ];

  if (loading) {
    return (
      <div className="bg-white rounded h-screen p-4">
        <Skeleton count={10} height={40} />
      </div>
    );
  }

  const rows = invoices?.map((invoice: InvoiceDto, index) => {
    return {
      _id: invoice._id,
      no: index + 1,
      totalprice: (invoice.order as OrderData).paidPrice,
      orderId: (invoice.order as OrderData)._id,
      invoiceNo: invoice.invoiceNumber,
      paymentChannel: invoice.paymentType,
      installmentCount: invoice.installmentCount,
      paymentStatus: invoice.paymentStatus,
    };
  });

  return (
    <div className="w-full bg-white">
      <DataGrid
        rows={rows}
        columns={columns}
        pageSizeOptions={pageSizeOptions}
        checkboxSelection
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: pageSizeOptions[0] },
          },
        }}
        getRowId={(row) => row._id} // Benzersiz ID için _id kullan
        localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
      />
    </div>
  );
}
